import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, Grid, TextField } from '@material-ui/core';
import { useStyles } from '../styles';
import { useCommonStyles } from '../../../../styles';
import { CustomDialogTitle } from '../../../../components';
import { Link } from '../../RegistrationLinksModel';

interface Props {
  open: boolean;
  translation: any;
  link: Link;
  onClose: () => void;
  onEditLink: (id: string, linkName: string, isClientLink: boolean) => void;
}

export const EditLinkDialog: FC<Props> = ({ open, link, translation, onClose, onEditLink }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [name, setName] = useState('');

  useEffect(() => {
    if (link.partnershipClientShortLinkDetails) {
      setName(link.partnershipClientShortLinkDetails.linkName);
    }
    if (link.partnershipLinkDetails) {
      setName(link.partnershipLinkDetails.linkName);
    }
  }, [link]);

  const editLink = () => {
    onEditLink(link.partnershipClientShortLinkDetails ? link.partnershipClientShortLinkDetails.id : link.id || '', name, !!link.partnershipClientShortLinkDetails);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.edit_link_name} onClose={() => onClose()} />
      <Grid container direction="column">
        <Grid item xs={12}>
          <p className={commonClasses.formControlTitle}>{translation.link_name}</p>
          <TextField className={classes.inputField} value={name} onChange={(event) => setName(event.target.value)} variant="outlined" />
        </Grid>
      </Grid>
      <DialogActions className={classes.dialogAction}>
        <Button onClick={editLink} className={`${commonClasses.activeDialogBtn} ${classes.btn}`}>
          {translation.text_10}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
